import * as React from 'react';
import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={526}
    height={162}
    fill="none"
    viewBox="0 0 526 162"
    {...props}
  >
    <path
      fill="currentColor"
      d="M0 131.881h17.3v-9.67c4.685 5.337 11.344 12.267 26.51 12.267 28.787 0 39.126-26.987 39.126-43.014 0-21.22-15.596-42.44-39.556-42.44-8.794 0-18.002 3.314-24.534 9.957V25.065H0V131.88Zm17.731-41.134c0-11.693 8.937-24.103 23.402-24.103 11.917 0 22.973 9.383 22.973 24.964 0 15.58-10.355 25.266-22.686 25.266-11.056 0-23.673-8.38-23.673-26.127h-.016ZM166.622 100.415c.573-2.597 1.131-5.91 1.131-9.67 0-20.2-14.895-41.723-40.688-41.723-25.792 0-41.404 20.36-41.404 43.013 0 22.654 17.588 42.44 41.548 42.44 18.575 0 33.455-13.43 37.995-27.863h-19.85c-3.552 6.643-9.781 10.243-18.145 10.243-13.478 0-20.838-11.263-21.698-16.456h61.111v.016Zm-61.685-15.437c3.537-14.864 14.609-18.337 22.256-18.337 10.068 0 19.149 5.48 21.268 18.337h-43.524ZM253.193 51.762h-17.301v10.1h-.287c-.573-1.147-10.068-12.84-26.094-12.84-21.842 0-39.413 17.747-39.413 42.296 0 26.7 18.002 43.157 38.282 43.157 9.924 0 21.554-5.337 27.512-12.554v9.957h17.301V51.762Zm-17.858 39.843c0 14.863-9.925 25.266-22.973 25.266-13.047 0-23.402-11.119-23.402-24.677 0-11.98 7.933-25.553 23.402-25.553 11.2 0 22.973 8.38 22.973 24.964ZM261.873 131.905h18.862V91.918c0-8.523 0-25.266 15.023-25.266 11.63 0 15.74 9.813 15.74 20.79v44.463h18.862V91.918c0-5.05-.144-12.984 2.836-17.747 2.692-4.62 7.806-7.503 13.047-7.503 14.895 0 14.895 16.17 14.895 20.79v44.462H380V85.147c0-11.836-2.835-19.483-5.958-23.673-2.835-4.046-10.498-12.41-25.951-12.41-5.528 0-17.158.574-25.378 12.553-7.376-11.55-18.432-12.553-22.686-12.553-13.604 0-19.005 6.93-20.566 9.527h-.287v-6.787h-17.301v80.116-.015Z"
      style={{
        fill: 'currentColor',
        fillOpacity: 1,
      }}
    />
    <path
      fill="#868686"
      d="M524.865 24.595V132h-17.304V24.595h17.304ZM398.268 132l40.724-100.245c.895-2.188 2.437-3.928 4.625-5.221 2.187-1.293 4.624-1.94 7.309-1.94 2.486 0 4.774.647 6.862 1.94 2.188 1.293 3.729 3.033 4.624 5.221L503.137 132H484.49l-10.591-27.597h-46.841L416.168 132h-17.9Zm69.962-42.067a1674.681 1674.681 0 0 0-8.801-23.719 6231.447 6231.447 0 0 1-8.652-23.718l-17.901 47.437h35.354Z"
      style={{
        fill: '#868686',
        fillOpacity: 1,
      }}
    />
  </svg>
);
export default SvgComponent;
